// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"5152d51a","57":"e914985d","208":"8b0cf484","234":"bc5de2d0","372":"b9ba4ad2","389":"eeeb9465","553":"13a7e7a9","788":"b746e4a4","789":"2e673c58","882":"1f108f31","969":"def5b5f5"}[chunkId] + ".chunk.js";
};